module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/breadcrumb/breadcrumb.component.scss
// module id = ./src/app/breadcrumb/breadcrumb.component.scss
// module chunks = main